export default __webpack_public_path__ + "static/media/Xcelium.f003c3e4.webp";